import { combineReducers } from 'redux';

import toastReducer from '../components/Toast/toast.store';
// import DietReducer from '../pages/Diets/diet.store';
import DietReducer from '../pages/DietManagement/diet.store';
import SnackBarReducer from '../components/Snackbar/snackbar.store';
import loginReducer, { APP_LOGOUT } from '../pages/Login/login.store';
import resetReducer from '../pages/ChangePassword/resetPassword.store';
import PatientListsReducer from '../pages/PatientList/patientList.store';
import HealthVaultReducer from '../pages/HealthVault/health.vault.store';
import clinicalNotesReducer from '../pages/ClinicalNotes/ClinicalNotes.store';
import clinicManagementReducer from '../pages/ClinicManagement/clinic.management.store';
import patientInvitationReducer from '../pages/PatientInvitation/patient.invitation.store';
import patientManagementReducer from '../pages/PatientManagement/patient.management.store';
import profileReducer from '../pages/Profile/profile.store';
import healthCardReducer from '../pages/HealthCard/health.card.store';

import { APP_TOKEN, REFRESH_TOKEN, UID, FCM_TOKEN } from '../helpers/Constants';

const reducers = {
	toastStore: toastReducer,
	DietStore: DietReducer,
	AuthStore: loginReducer,
	SnackBarStore: SnackBarReducer,
	ResetPasswordStore: resetReducer,
	HealthVaultStore: HealthVaultReducer,
	PatientListsStore: PatientListsReducer,
	clinicalNotesStore: clinicalNotesReducer,
	clinicManagementStore: clinicManagementReducer,
	patientInvitationStore: patientInvitationReducer,
	patientManagementStore: patientManagementReducer,
	profileStore: profileReducer,
	healthCardStore: healthCardReducer,
};

const appReducer = combineReducers(reducers);

const rootReducer = (state, action) => {
	let appStates = { ...state };
	if (action.type === APP_LOGOUT) {
		[APP_TOKEN, REFRESH_TOKEN, UID, FCM_TOKEN].forEach((item) => localStorage.removeItem(item));
		appStates = undefined;
	}

	return appReducer(appStates, action);
};

export default rootReducer;
